import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { BRANDS_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { clearAdminBrandsSignals } from "./@signals"
import AdminBrandsForm from "./Drawer"
import AdminBrandsTable from "./Table"
import BrandMergeModal from "./MergeModal"
import MergeResultModal from "./MergeModal/ResultModal"


export default function BrandsCrudPage() {

    useEffect(() => {
        return clearAdminBrandsSignals
    }, [])

    return <PageWrapper
        head={`${BRANDS_ROUTES.TITLE} | Brand Management`}
        title="Brand Management"
        subtitle="Create, edit and manage brands across all customers"
        actions={null}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <AdminBrandsTable />
            </Grid>
        </Grid>

        <AdminBrandsForm />
        <BrandMergeModal />
        <MergeResultModal />
    </PageWrapper>
}
